import { useContext } from 'react';

import { UserContext } from '../../components';

export const useIsLoggedIn = (): [boolean] => {
  const usercontext = useContext(UserContext);

  return [usercontext.isLoggedIn];
};
